import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import DestinationCraneMasterModalPage from '../../../containers/masters/DestinationCrane/DestinationCraneMasterModalPage'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class DestinationCraneMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchUO: null,
        searchName: null,
        searchDescription: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchDestinationCraneMaster()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchDestinationCraneMaster({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchDestinationCraneMaster({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleOrganizedUnitChange (searchUO) {
    if (!searchUO || searchUO.length === 0) {
      this.setState({ filter: { ...this.state.filter, searchUO: [] } })
      return
    }
    const searchUoList = searchUO.split(',').map((item) => {
      return parseInt(item)
    })
    if (this.state.filter.searchUO !== searchUoList) {
      this.setState({ filter: { ...this.state.filter, searchUO: searchUoList } })
    }
  }

  handleNameChange (searchName) {
    if (this.state.filter.searchName !== searchName) {
      this.setState({ filter: { ...this.state.filter, searchName } })
    }
  }

  handleDescriptionChange (searchDescription) {
    if (this.state.filter.searchDescription !== searchDescription) {
      this.setState({ filter: { ...this.state.filter, searchDescription } })
    }
  }

  searchDestinationCrane () {
    this.props.actions.fetchDestinationCraneMaster({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchUO: null,
        searchName: null,
        searchDescription: null
      }
    }, () => { this.searchDestinationCrane() })
  }

  componentDidUpdate (prevProps) {

  }

  render () {
    const {
      t, destinationCraneList, pagesCount, destinationCraneCount, filter, filter: { page },
      combos: { UOTreeCombo },
      actions: { fetchDestinationCraneItem, fetchDestinationCraneMaster, deleteDestinationCraneItem }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'destinationCraneMasterPage' })

    const tKey = 'MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const hasFilters = (this.state.filter.searchUO || this.state.filter.searchName)

    return (
      <>
        <div id='destinationCraneMaster' className="inner-results-panel">
          <div className="section-results-header">
            <div className="section-header-title">
              <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
                <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
              </OverlayTrigger>
              <h4>{t(`${secMapMasters.title}`)}</h4>
              <Button
                className="_Btn new"
                onClick={() => fetchDestinationCraneItem(null, true)}>
                <i className='iDocIcon-add-plus'></i>  {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
              </Button>
            </div>
            <div className='filters'>
              <div className="search-form">
                <Field
                  component={InputTreeSelect}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  name="destCraneFilters.organizedUnit"
                  controlLabel={t(`${tKey}DESTINATION_CRANE_MASTER.ORGANIZED_UNIT`)}
                  placeholder={t(`${tKey}DESTINATION_CRANE_MASTER.ORGANIZED_UNIT`)}

                  multi={true}
                  valueKey="value"
                  labelKey="label"
                  childrenKey="children"
                  options={UOTreeCombo}
                  onInputChange={(value) => this.handleOrganizedUnitChange(value)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  name="destCraneFilters.name"
                  controlLabel={t(`${tKey}DESTINATION_CRANE_MASTER.NAME`)}
                  placeholder={t(`${tKey}DESTINATION_CRANE_MASTER.NAME`)}
                  onInputChange={(value) => this.handleNameChange(value)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  name="destCraneFilters.description"
                  controlLabel={t(`${tKey}DESTINATION_CRANE_MASTER.DESCRIPTION`)}
                  placeholder={t(`${tKey}DESTINATION_CRANE_MASTER.DESCRIPTION`)}
                  onInputChange={(value) => this.handleDescriptionChange(value)}
                />
                <div className="search-form-actions flexInLine al-R">
                  <Button
                    className={'_Btn accept'}
                    onClick={() => this.searchDestinationCrane()}
                    onKeyDown={(e) => handleKeyDown(e)}>
                    <i className="ico-search" />
                    {t(`${tKey}SEARCH_BTN`)}
                  </Button>
                  <Button
                    className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                    onClick={() => {
                      this.props.initialize({})
                      this.resetFilters()
                    }}
                  >
                    <i className="ico-cancel" />
                    {t(`${tKey}RESET_BUTTON`)}
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className='section-results-body'>
            <div className={'searchResoultsContainer'}>
              <div className="table-wrapper" key="table-wrapper">

                {/* table */}
                {(destinationCraneList.length !== 0) &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('name') }}>
                        {t(`${tKey}DESTINATION_CRANE_MASTER.NAME`)}
                        <i className={this.getSortIcon('name')} />
                      </th>
                      <th onClick={() => { this.changeOrder('code') }}>
                        {t(`${tKey}DESTINATION_CRANE_MASTER.ORGANIZED_UNIT`)}
                        <i className={this.getSortIcon('code')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {destinationCraneList && destinationCraneList.map((destCrane, idx) => {
                      return (
                        <tr key={idx} className={(destCrane.isDeleted ? 'is-deleted' : '')}>
                          <td>{destCrane.name}</td>
                          <td>{destCrane.organizedUnit}</td>
                          <td className='actions'>
                            <div>
                              <OverlayTrigger placement="left" overlay={editTooltip}>
                                <a className='_Btn accept stk o-icn ' onClick={() => fetchDestinationCraneItem(destCrane, true)}>
                                  <i className="iDocIcon-edit" />
                                </a>
                              </OverlayTrigger>
                              {destCrane.canBeDeleted
                                ? <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => deleteDestinationCraneItem(destCrane.destinationCraneId)}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger> : null
                              }
                            </div>
                          </td>
                        </tr>)
                    })
                    }

                  </tbody>
                </Table>
                }
                {(destinationCraneList === null || destinationCraneList === undefined || destinationCraneList.length === 0) &&
                  <p className="no_results" >{t(`${tKey}DESTINATION_CRANE_MASTER.RESULTS_NOT_FOUND`)}</p>
                }
                <div className="section-users-footer">
                  <nav key={1} className="text-center">
                    <IDocCarPagination
                      id="btn_pag_sales"
                      page={page}
                      pagesCount={pagesCount}
                      totalRows={destinationCraneCount}
                      onSelectAction={(value) => fetchDestinationCraneMaster({ ...filter, ...this.state.filter, page: value })}
                    />
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <DestinationCraneMasterModalPage />
        </div>
      </>
    )
  }
}

export default reduxForm({
  form: 'destinationCraneMaster'
})(DestinationCraneMaster)
